import React, { useEffect, useState } from 'react';
import './styles.css';
import { Box } from '@material-ui/core';
import ImageUploadingField from '../image';

interface ImageFiles {
  id: string;
  rawFile: File;
}

const ImagesUploaderList = (props) => {
  const { images, onRemove } = props;
  const [files, setFiles] = useState(Array<ImageFiles>());

  useEffect(() => {}, []);
  //   useEffect(() => {
  //     let imgs = props.images.map((img) => {
  //       // return {src: `${process.env.REACt.}`}
  //     });
  //   }, [props.images]);

  return (
    <Box className='images-uploader-grid'>
      {images.map((image, index) => {
        return (
          <ImageUploadingField
            key={image.id}
            index={index}
            id={image.id}
            img={image}
            onRemove={onRemove}
          />
        );
      })}
    </Box>
  );
};

export default ImagesUploaderList;
